export default __webpack_public_path__ + "static/media/monorail.23bc6e2d.png";